<script type="text/jsx">
import UiButton from './UiButton.vue';

export default {
    functional: true,
    props: {
        rippleDuration: {
            type: Number,
            default: 400,
        },
        tag: {
            default: 'button',
            type: String,
        },
        constrainRipple: {
            type: Boolean,
            default: false,
        },
    },
    render(h, { props, data, children }) {
        data.props = props;
        data.class = ['ui-text-button', data.class, data.staticClass];

        if (data.props.constrainRipple) {
            data.class.push('constrain-ripple');
        }

        return <UiButton {...data}>{children}</UiButton>;
    },
};
</script>

<style lang="scss">
    $animation-normal: 0.4s;
    $circle-md: 20px;

    .ui-text-button {
        @apply text-size-5 leading-5 no-underline relative cursor-pointer;
        background: none;

        &.text-3 {
            @apply text-size-3 leading-3;
        }

        &:hover {
            @apply text-ultrablue;
        }

        &.btn-ripple-wrap {

            .circle {
                @apply bg-purple;
                width: $circle-md;
                height: $circle-md;
                animation: scale-text-circle $animation-normal;
                border: none;
                opacity: 0;
            }
        }

        &:not(.constrain-ripple).btn-ripple-wrap {
            overflow: visible;
        }

        &.ui-btn.disabled, &.ui-btn:disabled {
            @apply text-dust;
            background: none !important;
            box-shadow: none !important;
            border: 0 !important;
            cursor: not-allowed !important;
        }

        @keyframes scale-text-circle {
            from {
                transform: scale(.2);
                opacity: 0.2;
            }
            to {
                transform: scale(5);
                opacity: 0;
            }
        }
    }
</style>
